export const textStyles: Record<string, string> = {
  fontSize: '20pt',
  fontFamily: 'Work Sans',
};

export const profileTextStyles: Record<string, string> = {
  fontSize: '20pt',
  fontFamily: 'Work Sans',
};
